import { render, staticRenderFns } from "./communicationRecord.vue?vue&type=template&id=e6898f4e&scoped=true"
import script from "./communicationRecord.vue?vue&type=script&lang=js"
export * from "./communicationRecord.vue?vue&type=script&lang=js"
import style0 from "./communicationRecord.vue?vue&type=style&index=0&id=e6898f4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6898f4e",
  null
  
)

export default component.exports